var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"spinner"},[_c('BounceLoader',{attrs:{"size":"200px"}}),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }